import React from 'react';
import { Terminal, ArrowRight } from 'lucide-react';

const NewsletterCard = ({ spanClass = '' }) => {
  return (
    <div className={`relative overflow-hidden bg-zinc-950 p-8 md:p-12 rounded-2xl shadow-2xl flex flex-col justify-center border border-gray-800 ${spanClass} group`}>
      {/* Terminal Grid Background */}
      <div className="absolute inset-0 bg-grid-pattern bg-[length:30px_30px] opacity-20 pointer-events-none"></div>
      
      {/* Glowing Accents */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-trading-neon/10 rounded-full blur-[80px] group-hover:bg-trading-neon/20 transition-colors duration-700 pointer-events-none"></div>
      
      <div className="relative z-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-10">
        <div className="max-w-2xl">
          <div className="inline-flex items-center justify-center p-3 bg-zinc-900 rounded-xl mb-6 border border-gray-800">
            <Terminal className="w-6 h-6 text-trading-neon" />
          </div>
          
          <h2 className="text-3xl md:text-5xl font-display font-extrabold text-white mb-4 tracking-tighter leading-tight">
            Real Trading Insights.<br />
            <span className="text-gray-500">Delivered Weekly.</span>
          </h2>
          
          <p className="text-gray-400 text-lg max-w-xl leading-relaxed font-medium">
          Weekly emails where I break down what actually matters in trading.
          No signals. No hype. No selling — ever.
          </p>
        </div>

        <div className="flex-shrink-0 w-full md:w-auto">
          <a 
            href="https://tally.so/r/9q6dQX" 
            target="_blank" 
            rel="noopener noreferrer"
            className="group/btn relative inline-flex items-center justify-center w-full md:w-auto px-8 py-4 bg-trading-neon text-black text-sm font-mono font-bold uppercase tracking-wider rounded-xl hover:bg-white active:scale-95 transition-all duration-300 shadow-[0_0_20px_rgba(204,255,0,0.2)] hover:shadow-[0_0_30px_rgba(255,255,255,0.4)]"
          >
            JOIN_THE_NEWSLETTER
            <ArrowRight className="w-5 h-5 ml-3 group-hover/btn:translate-x-1 transition-transform" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default NewsletterCard;
